var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "a169371128e32fa14c60944b9c7541c0.png",
    width: 249,
    height: 244
});